"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.david.description': 'Głęboki, uspokajający ton z życzliwością i szczerością.',
};
